import {GameObject} from "../../base/GameObject";
import {Movie} from "../display/Movie";
import {MovieLayerMold} from "./MovieLayerMold";
import {LibraryFlump} from "./LibraryFlump";
import * as PIXI from 'pixi.js';
import {GameView} from "../../base/GameView";
import {Container} from "../display/Container";
import {Button} from "../display/Button";

export class MovieLayer extends GameObject {

  private _currentDisplay: PIXI.Container | null = null;
  private _displaysByFrames: (PIXI.Container | null)[] = [];
  private _library: LibraryFlump;
  private _layerMold: MovieLayerMold;

  constructor(movie: Movie, layerMold: MovieLayerMold, library: LibraryFlump) {
    super();
    this._library = library;
    this._layerMold = layerMold;

    for (let i = 0; i < layerMold.framesMolds.length; i++) {
      const frameMold = layerMold.framesMolds[i];
      if (frameMold) {
        const previousDisplay = this._displaysByFrames[i - 1];
        const previousMold = layerMold.framesMolds[i - 1];
        if (previousMold && previousDisplay && previousMold.ref && previousMold.ref === frameMold.ref) {
          this._displaysByFrames[i] = previousDisplay;
        } else {
          const display = library.create(frameMold.ref!);
          display.label = layerMold.name;
          this._displaysByFrames[i] = display;

          library.applyFrameState(display, frameMold);
          movie.addChild(display);

          display.visible = false;
        }
      } else {
        this._displaysByFrames[i] = null;
      }
    }
  }

  override destroy(): void {
    super.destroy();
    this._currentDisplay?.destroy();
  }

  public drawFrame(frameNumber: number): void {
    if (this._currentDisplay) {
      this._currentDisplay.visible = false;
    }

    // if (this._currentDisplay instanceof Button) {
    //   App.log(this._currentDisplay);
    // }

    let display = this._displaysByFrames[frameNumber - 1];
    if (display) {
      this._currentDisplay = display;
      if (this._currentDisplay) {

        this._library.applyFrameState(this._currentDisplay, this._layerMold.framesMolds[frameNumber - 1]!);

        // this._currentDisplay.position.set(frame.x, frame.y);
        // this._currentDisplay.scale.set(frame.scaleX, frame.scaleY);
        // this._currentDisplay.pivot.set(frame.pivotX, frame.pivotY);
        // // this._currentDisplay.skew.set(currentFrame.skewX, currentFrame.skewY);
        // this._currentDisplay.rotation = frame.skewX;
        // this._currentDisplay.alpha = frame.alpha;
        // this._currentDisplay.visible = frame.visible;
        // (this._currentDisplay as PIXI.Sprite).anchor.set(0);
        // App.log(currentFrame.alpha);
      }
    }
  }
}
